import './index.scss';

document.addEventListener("DOMContentLoaded", () => {
    const nodes = document.querySelectorAll('.video-odyssee');
    nodes.forEach(el => {
        const triggerDiv = el.querySelector('.triggerVideo');
        const videoElement = el.querySelector('video');

        if (triggerDiv && videoElement) {
            triggerDiv.addEventListener('click', () => {
                triggerDiv.classList.add('hidden')
                if (videoElement.paused) {
                    videoElement.play();
                    videoElement.setAttribute('controls', true);
                } else {
                    videoElement.pause();
                }
            });
        } else {
            console.error('Either the trigger div or the video element is missing.');
        }
    })
    
});